export class HiddenSfFields {

	/**
	 * @param {HTMLElement} elem - the form HTMLelement
	 * @constructor
	 */
	constructor(elem) {
		this.elem = elem;
		this.prefix = 'slfs__';

		this.init();
	}

	init() {
		const hiddenFields = window.hiddenSfFields;
		const hiddenFieldKeys = Object.keys(hiddenFields);
		const pageTitle = document.querySelectorAll('h1')[0] ? document.querySelectorAll('h1')[0].innerHTML : document.title;

		for (let i = 0; i < hiddenFieldKeys.length; i++) {
			const key = hiddenFieldKeys[i];
			const hiddenField = this.elem.querySelector(`input[type="hidden"][name^="${this.prefix}${key}"]`);
			this.handleStringValues(hiddenFields, key, pageTitle);
			this.handleUniqueName(hiddenFields, key, pageTitle);
			this.getDataFromSalesforceObject(hiddenFields, key);

			if (hiddenField) hiddenField.value = hiddenFields[key];
		}
	}

	/**
	 * Get data from <script data-salesforce-fields="">, get the keys of it, and set it as hiddenFields[key]
	 * @param hiddenFields
	 * @param key
	 */
	getDataFromSalesforceObject(hiddenFields, key) {
		if (hiddenFields[key].indexOf('.') > -1) {
			let index = hiddenFields[key].indexOf('.');
			let dataAttributeValue = hiddenFields[key].substring(0, index);
			let dataObject = document.querySelectorAll(`[data-salesforce-fields="${dataAttributeValue}"]`);
			dataObject = dataObject[0] ? dataObject[0] : '';
			if (dataObject) {
				dataObject = JSON.parse(dataObject.innerHTML);
				let dataObjectKey = hiddenFields[key].split('.').pop();
				hiddenFields[key] = dataObject[dataObjectKey];
			}
		}
	}

	/**
	 * Replace 'uuid' with first pageTitle page
	 * @param hiddenFields
	 * @param key
	 * @param pageTitle
	 */
	handleUniqueName(hiddenFields, key, pageTitle) {
		if (hiddenFields[key].startsWith('uniqueName')) {
			hiddenFields[key] = pageTitle + hiddenFields[key].substring('uniqueName'.length, hiddenFields[key].length);
		}
	}

	/**
	 * Replace default strings with correct values
	 * @param hiddenFields
	 * @param key
	 * @param pageTitle
	 */
	handleStringValues(hiddenFields, key, pageTitle) {
		switch (hiddenFields[key]) {
			case 'pageUrl':
				hiddenFields[key] = window.location.href;
				break;
			case 'pageTitle':
				hiddenFields[key] = pageTitle;
				break;
			default:
				hiddenFields[key];
				break;
		}
	}
}
